<template>
    <b-row class="vh-100" align-v="center">
        <b-col cols="12" md="8" offset-md="2" align-self="center">
            <b-row align-h="center">
                <b-col cols="12" align-self="center" style="text-align:center" class="mb-5">
                    <h3>VPFR</h3>
                    <p>{{ $t('vpfr.description') }}</p>
                </b-col>

                <b-col cols="12" md="6" align-self="center">
                    <SettingsForm @success="success"/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import OnboardingLayout from '@/components/integrations/OnboardingLayout.vue'
import SettingsForm from '@/views/integrations/protokol/vpfr/Form'

export default {
    components: {
        OnboardingLayout,
        SettingsForm
    },

    data: function() {
        return {}
    },

    i18n: {
        messages: {
            en_US: {
                vpfr: {
                    description: 'In order to use VPFR-a functionality you will need to provide some informations.'
                }
            },

            sr: {
                vpfr: {
                    description: 'Da biste koristili funkcionalnost VPFR-a, moraćete pružiti neke informacije.'
                }
            }
        }
    },

    methods: {
        success() {
            this.$emit('onboardingSuccess', 'integration', 'protokol-vpfr')
        }
    },

    mounted() {}
}
</script>